import {escapeHtml} from './utils/escapeHtml.js';
import {pushState} from './feature/history.js';

export function draw_one_email(email, type_id) {
	console.log(email, type_id);
	// Safely handle email.name_from
	let initials = '';
	if (email.name_from && typeof email.name_from === 'string') {
		initials = email.name_from
			.split(' ')
			.map(name => name[0])
			.join('')
			.substring(0, 2)
			.toUpperCase();
	} else {
		initials = '?'; // Default if name_from not available
	}

	// Generate HTML for attachments
	let attachmentHtml = '';
	if (email.attachments && email.attachments.length > 0) {
		attachmentHtml = `
			<div class="attachments">
				${email.attachments
			.map(att => {
				const is_generated_chunk = att.full_file_id > 0;
				let hidden_class = '';
				if (is_generated_chunk) {
					hidden_class = 'hidden';
					return '';
				}

				return `
					<div class="attachment-item ${hidden_class}">
						<img src="${getIconForAttachment(att)}" alt="attachment">
						<a href="${att.directory_path}/${att.email_id}/${att.file_name}" target="_blank">${att.file_name}</a>
					</div>
				`;
			}).join('')}
			</div>
		`;
	}

	// Create a snippet from the email HTML content
	let snippet = '';
	if (email.email_content) {
		// Create a temporary element to extract text from HTML
		let tempDiv = document.createElement('div');
		tempDiv.innerHTML = email.email_content;
		let textContent = tempDiv.textContent || tempDiv.innerText || '';
		textContent = textContent.trim();

		// Truncate to 130 chars
		if (textContent.length > 130) {
			snippet = textContent.substring(0, 130) + '...';
		} else {
			snippet = textContent;
		}
	}

	let own_class = '';
	if (type_id == 2) {
		own_class = 'own';
	}
	let reply_class = '';
	if (type_id == 3) {
		reply_class = 'reply';
	}
	// If docGuid && ims_added are set, we won't show the button
	let imsHtml = '';
	if (email.docGuid && email.ims_added) {
		const formattedDateTime = formatIMSDateTime(email.ims_added);
		imsHtml = `
            <div class="already-sent-ims">
                Email sent to IMS on:<br> 
                ${formattedDateTime}
            </div>
        `;
	} else {
		imsHtml = `
            <div class="submit_email_only_wrap block">
                <button data-email_id="${email.id}" class="btn submit_email_only">Email to IMS</button>
            </div>
        `;
	}

	// Create the HTML structure for each email (list view)
	const emailHtml = `
				<li class="email-item ${own_class} ${reply_class}" data-email-id="${email.id}">
					<div class="email-avatar">${initials}</div>
					<div class="email-info">
						<div class="email-from">${email.name_from || 'Unknown'} <span class="email_from_address">&lt;${email.email_from || 'No Email'}&gt;</span></div>
						<div class="email-subject sdf3">${email.email_subject || 'No Subject'}</div>
						
						 ${imsHtml}  <!-- Insert either button or "Already Sent" message -->
						 
						<div class="email-snippet">${snippet}</div>
						${attachmentHtml}
					</div>
					<div class="email-date">
						${email.formatted_date || 'No Date'}
						${email.attachments && email.attachments.length > 0 ? '<i class="fas fa-paperclip"></i>' : ''}
					</div>
					${email.priority ? '<div class="email-flag">!</div>' : ''}
				</li>
			`;

	return emailHtml;
}
function decodeHTMLEntities(str) {
	const textarea = document.createElement('textarea');
	textarea.innerHTML = str;
	// Now textarea.value should contain the decoded text
	return textarea.value;
}
export function draw_emails(emails) {
	$('.email-list').html(''); // Clear the list
	$('.email-detail-view').removeClass('active');
	$('#emails .email-detail-content').html('');

	if (Array.isArray(emails) && emails.length > 0) {
		emails.forEach(email => {
			let emailHtml = draw_one_email(email, 0);

			if (email.type_id == '2') {
				//2 - request email to Agent
				emailHtml = draw_one_email(email, 2);
			} else if (email.type_id == '1' || email.type_id == '6') {
				//1 - bot
				emailHtml = draw_one_email(email, 0);
			} else if (email.type_id == '3') {
				console.log(email);
				//3 reply from agent
				emailHtml = draw_one_email(email, 3);
			} else {
				emailHtml = draw_one_email(email, 0);
			}
			$('.email-list').append(emailHtml);
		});
	} else {
		// If there are no emails or empty array
		$('.email-list').append('<li>No emails found</li>');
	}

	// Add event listeners for email clicks to expand the view
	$('.email-item').on('click', function () {
		const emailId = $(this).data('email-id');
		const clickedEmail = emails.find(email => email.id == emailId);
		if (clickedEmail) {
			expandEmailView(clickedEmail);
		}
	});
}

function expandEmailView(email) {
	const $emailDetailView = $('#emails .email-detail-view');
	const $emailListView = $('#emails .email-list .email-item');
	const $emailDetailContent = $('#emails .email-detail-content');

	// Hide the list and show the detail view
	$emailListView.addClass('hidden');
	$emailDetailView.addClass('active');
	$emailDetailView.removeClass('hidden');

	let initials = '';
	if (email.name_from && typeof email.name_from === 'string') {
		initials = email.name_from.split(' ').map(name => name[0]).join('').substring(0, 2).toUpperCase();
	} else {
		initials = '?'; // Default if name_from is not available
	}

	let email_content = '';
	// Check if HTML body is available
	if (email.email_html_content && email.email_html_content.trim() !== '') {
		// Use the HTML version directly
		email_content = email.email_html_content;
	} else {
		// Otherwise, fallback to plain text
		email_content = (email.email_content ? email.email_content.replace(/\n{2,}/g, '<br><br>').replace(/\n/g, '<br>') : '');
	}

	// Build a small snippet for the "Email to IMS" area
	let imsHtml = '';
	if (email.docGuid && email.ims_added) {
		const formattedDateTime = formatIMSDateTime(email.ims_added);
		imsHtml = `
            <div class="already-sent-ims">
                Email sent to IMS on:<br> 
                ${formattedDateTime}
            </div>
        `;

	} else {
		imsHtml = `
            <div class="submit_email_only_wrap block">
                <button data-email_id="${email.id}" class="btn submit_email_only">Email to IMS</button>
            </div>
        `;
	}

	let root = document.implementation.createHTMLDocument();

	root.open();
	root.write(email_content);
	root.close();

	//Manipulate the DOM here
	// $(root).find("script, style, img").remove(); //jQuery is not relevant, I just didn't want to write exhausting boilerplate code just to make a point
	$(root).find('script').remove();

	/*<div class="email-avatar">${initials}</div>*/
	// Fill the detail view with the email content

	$emailDetailContent.html(`
<form id="email_content_form"></form>
		<button class="back-to-list ">← Back to List</button>
		<li class="email-item" data-email-id="${email.id}">
			
			<div class="email-info">
				<div class="email-header_wrap"> 
				
						<div class="email-subheader_wrap"> 
							<div class="email-from">${email.name_from || 'Unknown'} 
								<span class="email_from_address">&lt;${email.email_from || 'No Email'}&gt;</span>
								<div class="email-date">
									${email.formatted_date || 'No Date'}
								</div>
							</div>
							<div class="email-subject">${email.email_subject || 'No Subject'}</div>					
							 ${imsHtml}  <!-- Insert button or 'sent' message -->
						</div>
				</div>
					${email.attachments && email.attachments.length > 0 ? `
			 
				<div class="attachments_wrapper">
				${email.attachments
		.map(att => {
			const is_generated_chunk = att.full_file_id > 0;
			let hidden_class = '';
			if (is_generated_chunk) {
				hidden_class = 'hidden';
				return '';
			}

			let number_pages_html = '';
			if (att.num_pages > 0) {
				number_pages_html = `<span class="number_pages">${escapeHtml(att.num_pages)} pages</span>`;
			}
			let file_size_html = '';
			if (att.file_size) {
				file_size_html = `<span class="file_size">${escapeHtml(att.file_size)}</span>`;
			}
			console.error(att.disable_processing);
	 

			let processed_check_box_html = `<label class="process-file-toggle-wrap"><input type="checkbox" class="process-file-toggle-input" data-file_id="${escapeHtml(att.id)}" ${(Number(att.disable_processing) !== 1) ? 'checked' : ''}> process</label>`;


			return `
					<div class="attachment-item ${hidden_class}">
						<div class="filename">
							<img src="${getIconForAttachment(att)}" alt="attachment">
							<a href="${att.directory_path}/${att.email_id}/${att.file_name}" target="_blank">${att.file_name}</a>
						</div>
						<div class="details">
							${number_pages_html}
							${file_size_html}
							${processed_check_box_html}
						</div>
					</div>
				`;
		}).join('')}
				` : ''}
				</div>
				
				<div class="email-snippet"><iframe id="email_content_iframe" src="about:blank" referrerpolicy="no-referrer" frameborder="0" style="
    width: 100%;
    height: 60em;
    border: 1px solid #ddd;
"></iframe></div>
			
			</div>
			${email.priority ? '<div class="email-flag">!</div>' : ''}
		</li>
	`);


	// Copy the new HTML document into the frame

	let frame = $('#email_content_iframe').get(0);
	let destDocument = frame.contentDocument;
	let srcNode = root.documentElement;

	destDocument.open();
	destDocument.write(srcNode.outerHTML);
	destDocument.close();


	let currentUrl = window.location.href;
	let result = currentUrl.split('?')[0];
	let newUrl = result + `?emailId=${email.id}`;

	pushState(null, newUrl);

	// Add click event for the back button to return to list view
	$('.back-to-list').on('click', () => {
		$emailDetailView.removeClass('active');
		$emailListView.removeClass('hidden');
		let currentUrl = window.location.href.split('?')[0];
		pushState(null, currentUrl);
	});
}



// Helper function to get the correct icon for attachment types
function getIconForAttachment(attachment) {
	const ext = attachment.file_name.split('.').pop().toLowerCase();
	switch (ext) {
		case 'pdf':
			return 'data:image/svg+xml;base64,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';
		case 'doc':
		case 'docx':
			return 'data:image/svg+xml;base64,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';
		case 'xls':
			return 'data:image/svg+xml;base64,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';
		case 'xlsx':
			return 'data:image/svg+xml;base64,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';

		default:
			return 'data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiA/PjxzdmcgZGF0YS1uYW1lPSJMYXllciAxIiBpZD0iTGF5ZXJfMSIgdmlld0JveD0iMCAwIDI0IDI0IiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPjxkZWZzPjxzdHlsZT4uY2xzLTF7ZmlsbDojNzU3NTc1O30uY2xzLTJ7ZmlsbDojYmRiZGJkO30uY2xzLTN7ZmlsbDojZjVmNWY1O308L3N0eWxlPjwvZGVmcz48dGl0bGUvPjxwYXRoIGNsYXNzPSJjbHMtMSIgZD0iTTE2LjUsMjJoLTlhMywzLDAsMCwxLTMtM1Y1YTMsMywwLDAsMSwzLTNoNi41OWExLDEsMCwwLDEsLjcuMjlsNC40Miw0LjQyYTEsMSwwLDAsMSwuMjkuN1YxOUEzLDMsMCwwLDEsMTYuNSwyMloiLz48cGF0aCBjbGFzcz0iY2xzLTIiIGQ9Ik0xOC44LDcuNzRIMTUuMmExLjUsMS41LDAsMCwxLTEuNS0xLjVWMi42NGEuNTUuNTUsMCwwLDEsLjk0LS4zOUwxOS4xOSw2LjhBLjU1LjU1LDAsMCwxLDE4LjgsNy43NFoiLz48cGF0aCBjbGFzcz0iY2xzLTMiIGQ9Ik0xNiwxMi42NUg4YS41LjUsMCwwLDEtLjUtLjUuNS41LDAsMCwxLC41LS41aDhhLjUuNSwwLDAsMSwuNS41QS41LjUsMCwwLDEsMTYsMTIuNjVaIi8+PHBhdGggY2xhc3M9ImNscy0zIiBkPSJNMTYsMTUuNUg4YS41LjUsMCwwLDEsMC0xaDhhLjUuNSwwLDAsMSwwLDFaIi8+PHBhdGggY2xhc3M9ImNscy0zIiBkPSJNMTYsMTguMzVIOGEuNS41LDAsMCwxLS41LS41LjUuNSwwLDAsMSwuNS0uNWg4YS41LjUsMCwwLDEsLjUuNUEuNS41LDAsMCwxLDE2LDE4LjM1WiIvPjwvc3ZnPg==';
	}
}


function main() {
	// $('', process-file-toggle)
	$('#emails').on('change', '.process-file-toggle-input', function () {
		let $input = $(this);
		let checked = $input.prop('checked');

		let process = '0'
		if (checked) {
			process = '1';
		}
		let file_id = $input.attr('data-file_id');
		$.ajax({
			type: 'POST',
			dataType: 'json',
			url: '/leads/update-file-processing',
			data: {
				'file_id': file_id,
				'process': process,
			},
			cache: false,
			success: function (result) {
				if (result.code === 'SUCCESS') {

				} else {

				}
			},
			error: function () {
				alert('not saved!!');
			},
		});

	});
}
// A tiny helper to format your date/time nicely
function formatIMSDateTime(isoString) {
	// Convert "YYYY-MM-DD HH:MM:SS" into a proper Date object
	const [datePart, timePart] = isoString.split(' ');
	const [year, month, day] = datePart.split('-');
	const [hour, minute, second] = timePart.split(':');

	// Build a JS Date object
	const dt = new Date(year, month - 1, day, hour, minute, second);

	// e.g. using toLocaleString to get "1/19/2025, 9:19:00 PM"
	// Then do additional parsing if you want to drop seconds, etc.
	const options = {
		month: '2-digit',
		day: '2-digit',
		year: 'numeric',
		hour: 'numeric',
		minute: '2-digit',
		hour12: true,
	};
	return dt.toLocaleString([], options).replace(',', ' at');
	// e.g. "01/19/2025 at 9:19 PM"
}


main();
